import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce18b9f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aspect-ratio-inner" }

import { computed } from 'vue';

interface Props {
  ratio: [number, number];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AspectRatio',
  props: {
    ratio: { default: () => [1, 1] }
  },
  setup(__props: any) {

const props = __props as { ratio: [number, number] }



const styles = computed(() => ({
  paddingBottom: (100 * props.ratio[1] / props.ratio[0]) + '%',
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "aspect-ratio",
      style: _normalizeStyle(_unref(styles))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 4)
  ]))
}
}

})